export const changePageTitle = (title = "") => {
  if (title.trim()) {
    document.title = `Kepler - ${title}`;
  } else {
    document.title = `Kepler`;
  }
};
